export default "https://assets-v2.scaler.com/packs/images/simple-tick.526e35.svg";